/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-key */
import React, { Fragment } from 'react';

import {
  StatusValues,
  WMSStepTypesTranskey,
  TMSStepTypesTranskey,
  WMSStepTypes,
  TMSStepTypes,
} from './enums';

import SingleStatus from './singleStatus';

import { Container } from './styles';
import RenderBottom from './renderBottom';

function StatusFlow({
  wms,
  tms,
  isMobile,
  nfData,
  hasPosition,
  finishedDate,
  stepInvoice,
  openReceipt,
  hasReceipts,
  isAgroDivision,
  transferTripsCount,
}) {
  return (
    <Container isMobile={isMobile}>
      {wms && wms.length > 0 ? (
        wms.map((item, index) => (
          <Fragment>
            <SingleStatus
              key={item.title}
              isWMS
              isMobile={isMobile}
              changedStatusAt={item.changedStatusAt}
              title={WMSStepTypesTranskey[item.stepType]}
              stepType={item.stepType}
              statusType={item.statusType}
              first={index === 0}
              notHired={item.stepType === WMSStepTypes.NOT_INCLUDED} // Armazém não contratado
              notStarted={item.statusType === StatusValues.NOT_STARTED} // 1
              onHold={item.statusType === StatusValues.ON_HOLD} // 2
              inProgress={item.statusType === StatusValues.IN_PROGRESS} // 3
              completed={item.statusType === StatusValues.COMPLETED} // 4
              isAgroDivision={isAgroDivision}
            />
          </Fragment>
        ))
      ) : (
        <SingleStatus
          title={WMSStepTypesTranskey[WMSStepTypes.NOT_INCLUDED]}
          stepType={WMSStepTypes.CANCELED}
          isAgroDivision={isAgroDivision}
          first
        />
      )}
      {tms && tms.length > 0 ? (
        <Fragment>
          {tms.map((item, index) => {
            // For ARRIVAL_BRANCH, carry branchNameDestination from preceding TRANSFER_DELIVERY
            let arrivalBranchNameDestination;
            if (item.stepType === TMSStepTypes.ARRIVAL_BRANCH) {
              for (let i = index - 1; i >= 0; i--) {
                if (tms[i].stepType === TMSStepTypes.TRANSFER_DELIVERY && tms[i].branchNameDestination) {
                  arrivalBranchNameDestination = tms[i].branchNameDestination;
                  break;
                }
              }
            }
            return (
            <SingleStatus
              key={item.title}
              isMobile={isMobile}
              changedStatusAt={item.changedStatusAt}
              title={TMSStepTypesTranskey[item.stepType]}
              stepType={item.stepType}
              statusType={item.statusType}
              deliveryType={item.deliveryType}
              last={index === tms.length - 1}
              notHired={item.stepType === TMSStepTypes.NOT_INCLUDED} // Transporte não contratado
              notStarted={item.statusType === StatusValues.NOT_STARTED} // 1
              onHold={item.statusType === StatusValues.ON_HOLD} // 2
              inProgress={item.statusType === StatusValues.IN_PROGRESS} // 3
              completed={item.statusType === StatusValues.COMPLETED} // 4
              transferTripsCount={item.stepType === TMSStepTypes.TRANSFER_DELIVERY ? transferTripsCount : 0}
              branchNameSource={item.stepType === TMSStepTypes.TRANSFER_DELIVERY ? item.branchNameSource : undefined}
              branchNameDestination={item.stepType === TMSStepTypes.ARRIVAL_BRANCH ? arrivalBranchNameDestination : undefined}
              renderBottom={RenderBottom(
                item.stepType,
                item.statusType,
                stepInvoice,
                hasPosition,
                finishedDate,
                nfData.id,
                isAgroDivision,
              )}
              openReceipt={openReceipt}
              hasReceipts={hasReceipts}
              isAgroDivision={isAgroDivision}
            />
            );
          })}
        </Fragment>
      ) : (
        <SingleStatus
          title={TMSStepTypesTranskey[TMSStepTypes.NOT_INCLUDED]}
          stepType={TMSStepTypes.CANCELED}
          last
          isAgroDivision={isAgroDivision}
        />
      )}
    </Container>
  );
}

export default StatusFlow;
